import { Link } from 'react-router-dom';
import { GameCard } from '../components/GameCard';
import { MapPin, Mountain, Sun } from 'lucide-react';

const suedtirolContent = [
  {
    title: 'Wohnen in Südtirol',
    description: 'Welche Region in Südtirol passt am besten zu deinem Lebensstil? Finde es heraus.',
    image: 'https://images.unsplash.com/photo-1768464395439-25b2ef151f80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwZG9sb21pdGVzJTIwbW91bnRhaW4lMjB2aWxsYWdlJTIwc2NlbmljfGVufDB8fHx8MTc3NDI1Nzg4MHww&ixlib=rb-4.1.0&q=85',
    path: '/suedtirol/wohnen-in-suedtirol',
    type: 'quiz',
    featured: true
  }
];

export default function Suedtirol() {
  return (
    <div className="section-spacing" data-testid="suedtirol-page">
      <div className="container-wide">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <nav className="text-sm text-[#64748B] mb-4" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#0284C7]">Start</Link>
            <span className="mx-2">/</span>
            <span className="text-[#0F172A]">Südtirol</span>
          </nav>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Südtirol
          </h1>
          <p className="text-lg text-[#475569]">
            Regionale Tipps und Entscheidungshilfen zum Leben und Wohnen in 
            Südtirol. Von Bozen bis ins Pustertal.
          </p>
        </div>

        {/* Quick Info Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {[
            {
              icon: MapPin,
              title: 'Vielfältige Regionen',
              text: 'Von urban bis alpin – jede Region hat ihren eigenen Charakter.'
            },
            {
              icon: Mountain,
              title: 'Alpines Leben',
              text: 'Naturverbunden wohnen mit Blick auf die Dolomiten.'
            },
            {
              icon: Sun,
              title: 'Mediterranes Flair',
              text: 'Palmen und Berge – Südtirol vereint das Beste aus zwei Welten.'
            }
          ].map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="bg-white rounded-xl p-6 border border-[#E2E8F0]">
                <div className="w-10 h-10 rounded-lg bg-[#7C3AED]/10 flex items-center justify-center mb-4">
                  <Icon className="text-[#7C3AED]" size={20} />
                </div>
                <h3 className="font-semibold text-[#0F172A] mb-2">{item.title}</h3>
                <p className="text-sm text-[#475569]">{item.text}</p>
              </div>
            );
          })}
        </div>

        {/* Games Grid */}
        <h2 className="text-2xl font-bold text-[#0F172A] mb-6 font-[var(--font-heading)]">
          Finde deine Region
        </h2>
        <div className="bento-grid mb-12">
          {suedtirolContent.map((game, index) => (
            <GameCard key={index} {...game} />
          ))}
        </div>

        {/* Info Section */}
        <div className="bg-[#7C3AED]/5 border border-[#7C3AED]/20 rounded-xl p-8">
          <h2 className="text-xl font-semibold text-[#0F172A] mb-4 font-[var(--font-heading)]">
            Südtirol kennenlernen
          </h2>
          <p className="text-[#475569] mb-4">
            Bevor du dich für einen Wohnort in Südtirol entscheidest, solltest du 
            die verschiedenen Regionen selbst erleben. Ein Urlaub in einer 
            typischen Südtiroler Unterkunft gibt dir die Möglichkeit, das 
            authentische Leben vor Ort kennenzulernen.
          </p>
          <p className="text-[#475569]">
            Bei{' '}
            <a 
              href="https://kohlbrenner.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#7C3AED] hover:underline"
            >
              kohlbrenner.com
            </a>{' '}
            findest du authentische Unterkünfte, die dir einen echten Einblick 
            in das Leben in Südtirol ermöglichen.
          </p>
        </div>
      </div>
    </div>
  );
}
